import React, { useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Typography, Button } from '@material-ui/core';
import { Virtuoso } from 'react-virtuoso';
import useStyles from './styles';

import { convertObjToArr, sortArrByKey } from '../../../utils';
import Comment from '../../../components/Comment';
import Actions from '../../../store/ducks/comments';
import CommentItem from './CommentItem';

const Comments = () => {
  const dispatch = useDispatch();
  const [myCommentsArr, setMyCommentsArr] = React.useState([]);
  const {
    list: comments,
    loaded: commentsLoaded,
    error: commentsError,
  } = useSelector(state => state.comments.studentComments);
  const courses = useSelector(({ course }) => course.list);
  const classes = useStyles();

  const handleRequestComments = useCallback(() => {
    dispatch(Actions.requestStudentComments());
  }, [dispatch]);

  useEffect(() => {
    if (!commentsLoaded) {
      handleRequestComments();
    }
  }, [commentsLoaded, handleRequestComments]);

  useEffect(() => {
    const commentsArr = convertObjToArr(comments);
    setMyCommentsArr(sortArrByKey(commentsArr, 'createdAt', true));
  }, [comments]);

  const GenerateCommentItem = index => {
    const {
      description,
      createdAt,
      lessonId,
      courseId,
      status,
    } = myCommentsArr[index];

    const order = (() => {
      const courseItem = courses[courseId];
      if (!courseItem || !courseItem.lessons || !courseItem.lessons[lessonId]) {
        return '';
      }
      return courseItem.lessons[lessonId]?.order;
    })();

    return (
      <>
        {index === 0 && <Box className="list-top-spacing" />}
        <CommentItem
          description={description}
          createdAt={createdAt}
          courseId={courseId}
          lessonId={lessonId}
          courseName={courses[courseId]?.name}
          lessonOrder={order}
          status={status}
        />
      </>
    );
  };

  const statusList = useMemo(() => {
    if (!commentsError && !commentsLoaded) {
      return 'LOADING';
    }
    if (!commentsError && commentsLoaded && !myCommentsArr.length) {
      return 'EMPTY';
    }
    if (!commentsError && commentsLoaded && !!myCommentsArr.length) {
      return 'FILLED';
    }
    return 'ERROR';
  }, [commentsLoaded, commentsError, myCommentsArr.length]);

  return (
    <Box className={classes.container}>
      {statusList === 'LOADING' && (
        <Box className="comments-loading-container">
          <Comment isLoading />
        </Box>
      )}
      {statusList === 'ERROR' && (
        <>
          <Typography variant="body2" className="comments-message">
            Não foi possível carregar seus comentários
          </Typography>
          <Button
            size="small"
            color="primary"
            onClick={handleRequestComments}
            className="comments-button-retry"
          >
            Tentar novamente
          </Button>
        </>
      )}
      {statusList === 'EMPTY' && (
        <Typography variant="body2" className="comments-message">
          Você ainda não fez nenhum comentário
        </Typography>
      )}
      {statusList === 'FILLED' && (
        <Virtuoso
          className="comments-list-container"
          totalCount={myCommentsArr.length}
          overscan={200}
          item={GenerateCommentItem}
        />
      )}
    </Box>
  );
};

export default Comments;
